module.exports = __webpack_public_path__ + "img/pic04@2x.a4ae6421.png";